import React, { Component } from 'react'
import Select from 'react-select';
import { components } from 'react-select'
import { Modal, Form, Col, Button, Row } from 'react-bootstrap';

import SelectDropDown from '../selectdropdown/SelectDropDown';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import MultiSelect from "react-multi-select-component";
import { withRouter } from "react-router-dom";

const ADD_RESTRICTIONS = gql`
  mutation($params: EmployeeRestrictions) {
    addEmployeeRestrictions(params: $params)
  }`

class EmployeeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Username: "",
            password: "",
            email: "",
            contact_no: "",
            employeeType: 0,
            defaultvalue: 0,
            branch: "",
            loginUsername: "",
            usernameError: "",
            passwordError: "",
            emailError: "",
            contact_noError: "",
            employeeTypeError: "",
            branchError: "",
            loginUsernameError: "",

            employeeTypesOptions: [],
            collegeModulesOptions: [],

            modulesValue: [],
            qbsearchModules: [],

            subjectsValue: [],
            qbsearchSubjects: [],
            subjectOptions: [],

            selectedModulesArray: [],
            selectedModulesArrayError: "",

            dataClear: 0,

            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,
        };
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({ dataClear: 1, usernameError: "", Username: "", password: "", passwordError: "", email: "", emailError: "", contact_no: "", contact_noError: "", modulesValue: [], qbsearchModules: [], selectedModulesArray: [] })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    };

    componentDidMount() {

        let employeetypesArray = []
        let collegeModulesArray = []
        let subjectsArray = [];


        this.props.getEmployeeTypes && this.props.getEmployeeTypes.map((item) => {
            const newObj = {
                value: item.id,
                label: item.employee_type
            }
            employeetypesArray.push(newObj)
        })

        this.props.getCollegeModules && this.props.getCollegeModules.map((item) => {
            const newObj = {
                value: item.id,
                label: item.module_name

            }
            collegeModulesArray.push(newObj)
        })
        this.props.globals.offlineExamSubjects && this.props.globals.offlineExamSubjects.map((item) => {
            const newObj = {
                value: item.id,
                label: item.subject
            }
            subjectsArray.push(newObj)
        })
        this.setState({ employeeTypesOptions: employeetypesArray, collegeModulesOptions: collegeModulesArray, subjectOptions: subjectsArray })
    };

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        var pattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (name == "branch") {
            this.setState({ branch: value, branchError: "" })
        }
        if (name == "user_name") {
            this.setState({ Username: value, usernameError: "" })
        }
        if (name == "login_user_name") {
            this.setState({ loginUsername: value, loginUsernameError: "" })
        }
        if (name == "password") {
            this.setState({ password: value, passwordError: "" })
        }
        if (name == "email") {
            this.setState({ email: value })

            if (!pattern.test(value)) {
                this.setState({ emailError: "Please enter valid email" })
            } else {
                this.setState({ emailError: "" })
            }
        }
        if (name == "contact_no") {
            this.setState({ contact_no: value, contact_noError: "" })
            if (value.length <= 9 || value.length > 10) {
                this.setState({ contact_noError: "Mobile number must be 10 digits" })
            } else {
                this.setState({ contact_noError: "" })
            }
        }
        if (name == "employeetype") {
            this.setState({ employeeType: value, employeeTypeError: "" })
        }
    };

    handleMultipleSelectInputChange = (e, name) => {
        if (name == "modules") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            let modulesArray = Array()

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                        enabled: false,
                    }

                    const newObj1 = {
                        module_name: qbtopicval.label,
                        enabled: false
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                    modulesArray.push(newObj1)
                }
                this.setState({
                    modulesValue: qbsearchtopicvalue,
                    qbsearchModules: qbsearchtopic,
                    selectedModulesArray: modulesArray,
                    selectedModulesArrayError: ""
                });
            }
        }

        if (name == "subjects") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                        enabled: false,
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    subjectsValue: qbsearchtopicvalue,
                    qbsearchSubjects: qbsearchtopic,
                });
            }
        }
    };

    handleFormSubmit = () => {
        if (this.state.branch == "" || this.state.branch == 0) {
            this.setState({ branchError: "Please select Branch" })
            return ""
        }

        if (this.state.Username == "") {
            this.setState({ usernameError: "Please Enter Employee name", })
            return ""
        }

        if (this.state.loginUsername == "") {
            this.setState({ loginUsernameError: "Please enter user name" })
            return ""
        }

        if (this.state.password == "") {
            this.setState({ passwordError: "Please Enter Password", })
            return ""
        }
        if (this.state.contact_no == "" || this.state.contact_no.length > 10 || this.state.contact_no.length < 10) {
            this.setState({ contact_noError: "Please Enter Contact number", })
            return ""
        }
        if (this.state.email == "") {
            this.setState({ emailError: "Please Enter Email", })
            return ""
        }

        if (this.state.employeeType == 0) {
            this.setState({ employeeTypeError: "Please Select Employee Type" })
            return ""
        }


        if (this.state.employeeType == 3 && this.state.subjectsValue.length == 0) {
            this.setState({ selectedsubjectsError: "Please select Subjects" })
            return ""
        }

        if (this.state.selectedModulesArray.length == 0) {
            this.setState({ selectedModulesArrayError: "Please select Modules" })
            return ""
        }

        let params = {
            employee_name: this.state.Username,
            username: this.state.loginUsername,
            emp_mobile: this.state.contact_no,
            emp_email: this.state.email,
            password: this.state.password,
            employee_type_id: parseInt(this.state.employeeType),
            module_access: this.state.selectedModulesArray,
            subject_ids: this.state.qbsearchSubjects.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch)
        }

        this.addEmployeeRestrictions(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        });
    };

    addEmployeeRestrictions = async params => {
        await this.props.addEmployeeRestrictions({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addEmployeeRestrictions) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        this.props.onHide();
        window.location.reload(false);
    };

    render() {

        let modulesSelectAll = true;
        let modulesLabelledBy = "Select";
        let modulesdisablesearch = false;
        if (this.state.collegeModulesOptions.length > 0) {
            modulesSelectAll = true;
            modulesdisablesearch = false;
        }
        else {
            modulesdisablesearch = true;
            modulesSelectAll = false;
            modulesLabelledBy = "Modules"
        }
        let subjectSelectAll = true;
        let subjectLabelledBy = "Select";
        let subjectdisablesearch = false;
        if (this.state.subjectOptions.length > 0) {
            subjectSelectAll = true;
            subjectdisablesearch = false;
        }
        else {
            subjectdisablesearch = true;
            subjectSelectAll = false;
            subjectLabelledBy = "Subjects"
        }

        return (
            <Modal {...this.props}
                size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase">Branch</Form.Label>
                                <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch} >
                                    <option value={this.state.defaultvalue}>--Select Branch--</option>
                                    {this.props.globals.globalBranches.map(branchData => (
                                        <option value={branchData.id}>{branchData.branch_name}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.branchError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase"> Employee Name<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Employee Name"
                                    name="user_name"
                                    onChange={this.handleInputChange}
                                    autoComplete="off"
                                    value={this.state.Username}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.usernameError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase">Username<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="User Name"
                                    name="login_user_name"
                                    onChange={this.handleInputChange}
                                    autoComplete="off"
                                    value={this.state.loginUsername}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.loginUsernameError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase">Employee Password<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="Password"
                                    placeholder="Password"
                                    onChange={this.handleInputChange}
                                    autoComplete="new-password"
                                    name="password"
                                    value={this.state.password}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.passwordError}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase"> Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Email"
                                    name="email"
                                    onChange={this.handleInputChange}
                                    autoComplete="off"
                                    value={this.state.email}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.emailError}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} >
                                <Form.Label className="text-uppercase"> Contact No</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Mobile No"
                                    name="contact_no"
                                    onChange={this.handleInputChange}
                                    autoComplete="off"
                                    value={this.state.contact_no}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.contact_noError}
                                </Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase">Employee type</Form.Label>
                                <Form.Control as="select" name="employeetype" onChange={this.handleInputChange} value={this.state.employeeType} >
                                    <option value={this.state.defaultvalue}>Select Employee type</option>
                                    {this.props.getEmployeeTypes.map(item => (
                                        <option value={item.id}>
                                            {item.employee_type}
                                        </option>)
                                    )}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.employeeTypeError}
                                </Form.Text>
                            </Form.Group>

                            {
                                this.state.employeeType == 3 ?
                                    (
                                        <Form.Group as={Col} xl={6} lg={6} md={6} sm={12} controlId="SelectSubject">
                                            <Form.Label className="text-uppercase">Select Subjects</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Subjects are selected.",
                                                    "selectSomeItems": subjectLabelledBy
                                                }
                                                }
                                                disableSearch={subjectdisablesearch}
                                                hasSelectAll={subjectSelectAll}
                                                options={this.state.subjectOptions}
                                                value={this.state.subjectsValue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "subjects")}
                                                labelledBy={"Subjects"}
                                            />
                                            <Form.Text className="form-text text-danger">
                                                {this.state.selectedsubjectsError}
                                            </Form.Text>
                                        </Form.Group>
                                    )
                                    :
                                    ("")
                            }

                            <Form.Group as={Col} xl={6} lg={6} md={6} sm={12} controlId="SelectSubject">
                                <Form.Label className="text-uppercase">Select College Modules</Form.Label>
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Modules are selected.",
                                        "selectSomeItems": modulesLabelledBy
                                    }
                                    }
                                    disableSearch={modulesdisablesearch}
                                    hasSelectAll={modulesSelectAll}
                                    options={this.state.collegeModulesOptions}
                                    value={this.state.modulesValue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "modules")}
                                    labelledBy={"Modules"}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.state.selectedModulesArrayError}
                                </Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer variant="white" className="px-4">
                    <Row>
                        <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                            <Button onClick={this.handleFormSubmit} className="btn btn-success text-uppercase" >
                                {
                                    this.state.loadingSpinner == 1 ?
                                        (<div class="spinner-border text-light  loading-img-center mr-2" style={{ width: "1rem", height: "1rem" }}></div>)
                                        :
                                        ("")
                                }
                                Save
                            </Button>
                        </Col>
                        {this.state.currentStep == 5 ? (
                            <Form.Text className="form-text text-danger mb-2 f-10 " style={{ textAlign: "center", fontSize: "12px" }}>
                                Data Saved successfully
                            </Form.Text>
                        ) : (
                            <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", fontSize: "12px" }}>
                                {this.state.submitError}
                            </Form.Text>
                        )}
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default
    graphql(ADD_RESTRICTIONS, {
        name: "addEmployeeRestrictions"
    })
        (EmployeeModal);